export default __webpack_public_path__ + "static/media/illustration-grow-together.3c29212c.svg";